"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationCard = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_button_1 = require("@travelnest/merlin.button");
const merlin_button_icon_1 = require("@travelnest/merlin.button-icon");
const merlin_icon_text_span_1 = require("@travelnest/merlin.icon-text-span");
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const merlin_typography_1 = require("@travelnest/merlin.typography");
const React = __importStar(require("react"));
const CardWrapper = styled_1.default.div `
	padding: ${merlin_theme_1.default.layout.spacing.standard};
	position: relative;
	border-radius: ${merlin_theme_1.default.layout.radius.default};
	background-color: ${merlin_theme_1.default.paletteV5.greyscale.white};
	width: 100%;

	& > button {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background-color: ${merlin_theme_1.default.paletteV5.greyscale.gray3};
		font-size: ${merlin_theme_1.default.typographyV5.micro.fontSize};
		font-weight: ${merlin_theme_1.default.typographyV5.micro.fontWeight};
		opacity: 0.4;

		& div div:after {
			width: 9px;
			height: 9px;
		}
	}

	@media only screen and (min-width: 768px) {
		max-width: 515px;
	}
`;
const ScoreWrapper = styled_1.default.span `
	height: 28px;
	width: 44px;
	border-radius: 17px;
	color: ${merlin_theme_1.default.paletteV5.greyscale.gray1};
	display: grid;
	align-items: center;
	justify-content: center;
	font-size: ${merlin_theme_1.default.typographyV5.p.fontSize};
	font-weight: 600;
	margin-right: ${merlin_theme_1.default.layout.spacing.small};
	flex-shrink: 0;
`;
const StyledHeading = (0, styled_1.default)(merlin_typography_1.Heading) `
	margin-right: ${merlin_theme_1.default.layout.spacing.small};
`;
const ContentWrapper = styled_1.default.div `
	display: flex;
	flex-direction: column;
	margin-right: ${merlin_theme_1.default.layout.spacing.smallest};
`;
const StyledPillLinkButton = (0, styled_1.default)(merlin_button_1.PillLinkButton) `
	font-size: ${merlin_theme_1.default.typographyV5.p.fontSize};
	font-weight: 600;
`;
const Incomplete = ({ onCrossClick, points, action, buttonLink, buttonText, isSnoozed, status }) => {
    return (React.createElement(React.Fragment, null,
        !isSnoozed && React.createElement(merlin_button_icon_1.IconButton, { "data-testid": "recommendation-card--snooze-button", icon: "cross", colour: "white", onClick: onCrossClick }),
        React.createElement(ContentWrapper, null,
            React.createElement("div", null,
                React.createElement(StyledHeading, { style: merlin_theme_1.default.typographyV5.h3, "data-testid": "recommendation-card--status-text" }, status)),
            React.createElement(merlin_spacer_1.Spacer, { spacing: "small" }),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(ScoreWrapper, { style: { backgroundColor: merlin_theme_1.default.paletteV5.green.primary } }, `▲ ${points}`),
                React.createElement(merlin_typography_1.Paragraph, { style: merlin_theme_1.default.typographyV5.p, "data-testid": "recommendation-card--action-text" }, action))),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "small" }),
        React.createElement(StyledPillLinkButton, { to: buttonLink, label: buttonText, buttonType: merlin_button_1.PresetThemes.ThemeV5Primary, "data-testid": "recommendation-card--button-text" }, buttonText)));
};
const Complete = ({ status, updatedAt }) => {
    return (React.createElement(ContentWrapper, null,
        React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(merlin_icon_text_span_1.IconTextSpan, { icon: 'check', display: 'success', text: "" }),
            React.createElement(merlin_typography_1.Heading, { style: merlin_theme_1.default.typographyV5.h3, "data-testid": "recommendation-card--status-text" }, status))));
};
const RecommendationCard = (props) => {
    const { isComplete } = props;
    return (React.createElement(CardWrapper, { className: "recommendation-card" }, isComplete ? React.createElement(Complete, Object.assign({}, props)) : React.createElement(Incomplete, Object.assign({}, props))));
};
exports.RecommendationCard = RecommendationCard;
//# sourceMappingURL=RecommendationCard.js.map